/*
 * @Description:保险接口
 * @Version: 2.0
 * @Author: liangdengke
 * @Date: 2022-07-09 13:50:11
 * @LastEditors: your Name
 * @LastEditTime: 2022-08-02 01:43:29
 */
// 页面右侧查询列表
import $axios from "@/utils/$axios";
const insuraApi = {
    getOccupationCodeListUrl: "/occupationCode/getOccupationCodeList", //职业表
    personnelInfoUrl: "/insurancePersonnel/personnelInfo", //获取客户信息
    saveUrl: "/insurancePersonnel/save", //客户信息保存
    submitListUrl: "/insurance/submitList", //获取待提交表格信息
    approveListUrl: "/insurance/approveList", //获取待审核表格信息
    getInsuranceTechnologyUserListUrl: "/insuranceTechnologyUser/getInsuranceTechnologyUserList", //获取家庭资料信息
    technologyCreateUrl: "/insuranceTechnologyUser/create", //保存家庭资料
    classificationListUrl: "/classification/list", //获取保险分类
    notificationSaveUrl: "/notification/save", //保存告知信息
    insuranceCopyUrl: "/insurance/copy", //复制保单
    insuranceSubmitUrl: "/insurance/submit", //表格中的提交
    auditSaveUrl: "/audit/save", //核保保存
    insuranceInfoSaveUrl: "/insuranceInformation/save", //险种信息、分类保存接口

    getInsuranceTypeUrl: '/classification/list', //获取险种
    notificationSubmitUrl: '/notification/submit', //获取险种
    withdrawalUrl: '/insurance/withdrawal', //撤回提交
    getInsuranceTechnologyMainUserListUrl: '/insuranceTechnologyUser/getInsuranceTechnologyMainUserList', //获取财务规划列表数据
    informationUrl: '/insuranceInformation/information', //险种分类、险种信息获取接口

};

// 获取职业表
export function getOccupationCodeListFn(params) {
  return $axios({
    url: insuraApi.getOccupationCodeListUrl,
    method: "get",
    headers: {
      "Content-Type": "application/json"
    },
    params
  });
}
//获取客户信息
export function personnelInfoFn(params) {
  return $axios({
    url: insuraApi.personnelInfoUrl,
    method: "get",
    params
  });
}
//客户信息保存
export function saveFn(params) {
  return $axios({
    url: insuraApi.saveUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//获取待提交表格信息
export function submitListFn(params) {
  return $axios({
    url: insuraApi.submitListUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//获取待审核表格信息
export function approveListFn(params) {
  return $axios({
    url: insuraApi.approveListUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//获取家庭资料信息
export function getInsuranceTechnologyUserListFn(params) {
  return $axios({
    url: insuraApi.getInsuranceTechnologyUserListUrl,
    method: "get",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//保存家庭资料信息
export function technologyCreateFn(params) {
  return $axios({
    url: insuraApi.technologyCreateUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//获取险种分类
export function classificationListFn(params) {
  return $axios({
    url: insuraApi.classificationListUrl,
    method: "get",
    params
  });
}
//保存告知信息
export function notificationSaveFn(params) {
  return $axios({
    url: insuraApi.notificationSaveUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//复制信息
export function insuranceCopyFn(params) {
  return $axios({
    url: insuraApi.insuranceCopyUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//表格中的提交
export function insuranceSubmitFn(params) {
  return $axios({
    url: insuraApi.insuranceSubmitUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//核保保存
export function auditSaveFn(params) {
  return $axios({
    url: insuraApi.auditSaveUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//核保保存
export function insuranceInfoSaveFn(params) {
  return $axios({
    url: insuraApi.insuranceInfoSaveUrl,
    method: "post",
    data: params
  });
}

export function getInsuranceTypeFn(params) {
  return $axios({
    url: insuraApi.getInsuranceTypeUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//告知事项页面提交投保
export function notificationSubmitFn(params) {
  return $axios({
    url: insuraApi.notificationSubmitUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//撤回提交
export function withdrawalFn(params) {
  return $axios({
    url: insuraApi.withdrawalUrl,
    method: "post",
    headers: {
        "Content-Type": "application/json"
    },
    data: params
  });
}
//获取财务规划列表数据
export function getInsuranceTechnologyMainUserListFn(params) {
  return $axios({
    url: insuraApi.getInsuranceTechnologyMainUserListUrl,
    method: "get",
    headers: {
        "Content-Type": "application/json"
    },
    params
  });
}
//险种分类、信息获取
export function informationFn(params) {
  return $axios({
    url: insuraApi.informationUrl,
    method: "get",
    headers: {
        "Content-Type": "application/json"
    },
    params
  });
}